import {
  HTTP_INTERCEPTORS,
  provideHttpClient,
  withInterceptors,
  withInterceptorsFromDi,
} from "@angular/common/http";
import {
  ApplicationConfig,
  importProvidersFrom,
  LOCALE_ID,
} from "@angular/core";
import { provideAnimations } from "@angular/platform-browser/animations";
import { translocoProviders } from "./core/providers/transloco.providers";
import { JwtInterceptor } from "./core/interceptors/jwt.interceptor";
import {
  LocationStrategy,
  PathLocationStrategy,
  registerLocaleData,
} from "@angular/common";
import { provideRouter } from "@angular/router";
import { appRoutes } from "./app.routes";
import { MatSnackBarModule } from "@angular/material/snack-bar";
import { MatDialogModule } from "@angular/material/dialog";
import { MatCardModule } from "@angular/material/card";
import { MatDatepickerModule } from "@angular/material/datepicker";
import { MatSidenavModule } from "@angular/material/sidenav";
import { MatMenuModule } from "@angular/material/menu";
import { MatListModule } from "@angular/material/list";
import { ChangeTheme } from "./core/services/common/changeTheme.service";
import { DialogInitService } from "./core/services/common/dialog.service";
import { adapterFactory } from "angular-calendar/date-adapters/date-fns";
import {
  CalendarModule,
  DateAdapter as CalendarDateAdapter,
} from "angular-calendar";
import { DateAdapter as MatDateAdapter } from "@angular/material/core";
import { MatPaginatorModule } from "@angular/material/paginator";
import { MatTableModule } from "@angular/material/table";
import { MatButtonToggleModule } from "@angular/material/button-toggle";
import { MatIconModule } from "@angular/material/icon";
import { MAT_DATE_FORMATS, MAT_DATE_LOCALE } from "@angular/material/core";
import {
  MomentDateAdapter,
  MatMomentDateModule,
  MAT_MOMENT_DATE_ADAPTER_OPTIONS,
} from "@angular/material-moment-adapter";
import localeEs from "@angular/common/locales/es";
import moment from "moment";
import "moment/locale/es";
import { httpErrorInterceptor } from "@core/interceptors/http-error.interceptor";
import { globalLoadingInterceptor } from "@core/interceptors/global-loading.interceptor";

// Configurar moment en español
moment.locale("es");

registerLocaleData(localeEs);

// Formato personalizado para fechas
const MY_DATE_FORMATS = {
  parse: {
    dateInput: "DD/MM/YYYY",
  },
  display: {
    dateInput: "DD/MM/YYYY",
    monthYearLabel: "MMM YYYY",
    dateA11yLabel: "LL",
    monthYearA11yLabel: "MMMM YYYY",
  },
};

export const appConfig: ApplicationConfig = {
  providers: [
    provideHttpClient(
      withInterceptorsFromDi(),
      withInterceptors([globalLoadingInterceptor, httpErrorInterceptor]),
    ),
    provideAnimations(),
    translocoProviders,
    { provide: HTTP_INTERCEPTORS, useClass: JwtInterceptor, multi: true },
    {
      provide: MatDateAdapter,
      useClass: MomentDateAdapter,
      deps: [MAT_DATE_LOCALE, MAT_MOMENT_DATE_ADAPTER_OPTIONS],
    },
    { provide: MAT_DATE_FORMATS, useValue: MY_DATE_FORMATS },
    { provide: MAT_DATE_LOCALE, useValue: "es" },
    { provide: MAT_MOMENT_DATE_ADAPTER_OPTIONS, useValue: { useUtc: true } },
    { provide: LOCALE_ID, useValue: "es" },
    { provide: LocationStrategy, useClass: PathLocationStrategy },
    provideRouter(appRoutes),
    importProvidersFrom(
      MatSnackBarModule,
      MatDialogModule,
      MatCardModule,
      MatDatepickerModule,
      MatSidenavModule,
      MatMenuModule,
      MatIconModule,
      MatListModule,
      MatButtonToggleModule,
      MatTableModule,
      MatPaginatorModule,
      MatMomentDateModule,
      CalendarModule.forRoot({
        provide: CalendarDateAdapter,
        useFactory: adapterFactory,
      }),
    ),
    DialogInitService,
    ChangeTheme,
  ],
};
